/**
 * Barrel — combines all domain-specific route sub-modules into the unified MANIFEST array.
 *
 * Import order matches the original manifest.ts declaration order so that route
 * deduplication (first-entry wins in RouterConfig) and nav section ordering are preserved.
 */

import type { RouteEntry } from '../types';

export { PUBLIC_ROUTES } from './public';
export { AUDIT_WORKBOOK_ROUTES } from './auditWorkbook';
export { BUDGETING_ROUTES } from './budgeting';
export { ACTUARIAL_MODEL_ROUTES } from './actuarialModel';
export { REINSURANCE_ROUTES } from './reinsurance';
export { PRICING_ROUTES } from './pricing';
export { POLICY_DATA_ROUTES } from './policyData';
export { ADMIN_ROUTES } from './admin';
export { SYSTEM_ROUTES } from './system';

import { PUBLIC_ROUTES } from './public';
import { AUDIT_WORKBOOK_ROUTES } from './auditWorkbook';
import { BUDGETING_ROUTES } from './budgeting';
import { ACTUARIAL_MODEL_ROUTES } from './actuarialModel';
import { REINSURANCE_ROUTES } from './reinsurance';
import { PRICING_ROUTES } from './pricing';
import { POLICY_DATA_ROUTES } from './policyData';
import { ADMIN_ROUTES } from './admin';
import { SYSTEM_ROUTES } from './system';

// ─── All 7 RBAC roles for convenience ───────────────────────────────────────
export const ALL_ROLES: string[] = [
  'super_admin',
  'admin',
  'company_user',
  'consultant_user',
  'auditor',
  'regulator',
  'executive',
];

export const MANIFEST: RouteEntry[] = [
  ...PUBLIC_ROUTES,
  ...AUDIT_WORKBOOK_ROUTES,
  ...BUDGETING_ROUTES,
  ...ACTUARIAL_MODEL_ROUTES,
  ...REINSURANCE_ROUTES,
  ...PRICING_ROUTES,
  ...POLICY_DATA_ROUTES,
  ...SYSTEM_ROUTES,
  ...ADMIN_ROUTES,
];
